{
  "section_table": {
    "caption": "Company sections",
    "search": "Search sections",
    "inherited": "Inherited",
    "headings": {
      "name": "Section",
      "customer_group": "Customer group",
      "price_lists": "Price lists",
      "company_users": "Customers"
    },
    "actions": {
      "add_child": "Add sub-section"
    }
  },
  "section_form": {
    "parent": {
      "title": "Placement",
      "description": "Where this section sits in the company hierarchy. It inherits the settings of everything above it.",
      "label": "Parent section",
      "top_level": "Top level (directly under the company)",
      "top_level_named": "Top level (directly under {company})"
    }
  },
  "section_customers": {
    "title": "Customers",
    "description": "The company's customers who belong to this section, and what each one can do.",
    "select_label": "Assigned customers",
    "role_list_error": "We couldn't load the list of roles. Roles can't be changed until it loads.",
    "non_leaf": {
      "title": "This section has sub-sections",
      "description": "Customers can only belong to a section at the bottom of the hierarchy. Assign them to one of this section's sub-sections instead."
    },
    "table": {
      "caption": "Customers assigned to this section",
      "headings": {
        "customer": "Customer",
        "role": "Role"
      }
    }
  }
}
